import React from 'react'

import { CardBulletPoint } from '@frame/ui-components/card-bullet-point'

import calendar from '@frame/images/calendar.svg'
import dollar from '@frame/images/dollar.svg'

export function TenantBankContent() {
  return (
    <>
      <CardBulletPoint
        bold={false}
        descriptionSize="small"
        imgSrc={calendar}
        title="Provide proof of income from recent months"
        alignTop
      />
      <CardBulletPoint
        bold={false}
        descriptionSize="small"
        imgSrc={dollar}
        title="Connect as many accounts as needed to show your full income picture"
        alignTop
      />
    </>
  )
}
